// extracted by mini-css-extract-plugin
export var content = "styles-module--content--UFkMK";
export var highlight = "styles-module--highlight--Jr33r";